export interface AdminTxnOrgRef {
  id: number;
  name: string;
  slug: string;
}

export interface AdminTxnCreatedBy {
  id: number;
  email: string;
  name: string;
}

/** One row of GET /admin/transactions deliberate wallet movements only
 *  (topup/grant/adjustment/refund). Ordinary API spend is NOT here see
 *  the contract's gotcha #1, it lives in /admin/calls instead. */
export class AdminTransactionRow {
  id!: number;
  kind!: string;
  amountCents!: number;
  balanceAfterCents!: number;
  currency!: string;
  description: string | null = null;
  reference: string | null = null;
  organization: AdminTxnOrgRef | null = null;
  /** Null for anything the platform did itself a welcome grant, a Stripe webhook. */
  createdBy: AdminTxnCreatedBy | null = null;
  createdAt!: string;

  constructor(data: any = {}) {
    this.id = data.id;
    this.kind = data.kind;
    this.amountCents = data.amount_cents;
    this.balanceAfterCents = data.balance_after_cents;
    this.currency = data.currency;
    this.description = data.description ?? null;
    this.reference = data.reference ?? null;
    this.organization = data.organization ?? null;
    this.createdBy = data.created_by ?? null;
    this.createdAt = data.created_at;
  }

  get isCredit(): boolean {
    return this.amountCents >= 0;
  }
}

export class AdminTransactionTotals {
  creditedCents!: number;
  debitedCents!: number;
  currency!: string;

  constructor(data: any = {}) {
    this.creditedCents = data.credited_cents;
    this.debitedCents = data.debited_cents;
    this.currency = data.currency;
  }
}
